import AppConstants from "../appConstants";
import jwt_decode from "jwt-decode";
import store from '../store/store';
import localStorageHelper from "./local-storage-helper";
import VueI18n from "../i18n/i18n";
import i18n from "../i18n/i18n";
import { getMomentLocale } from "./locale-helper";

const reactResponseTimeout = 8000;
class BiometryHelper {
  // Used in switch to activate biometry
  show(successCallback, errorCallback) {
    const disableBackup = false;
    const fallbackButtonTitle = disableBackup ? VueI18n.t('BIOMETRY').Cancel : VueI18n.t('BIOMETRY').Use_Pin;

    const infoErrorCallback = (error) => {
      console.info('Falha na autenticação biométrica:', error);
      if (errorCallback) {
        errorCallback(error);
      }
    };
    const description = VueI18n.t('BIOMETRY').Show_Fingerprint_Desc;

    Fingerprint.show({
      description: description,
      fallbackButtonTitle: fallbackButtonTitle,
      disableBackup: disableBackup,
    }, successCallback, infoErrorCallback);
  }

  // Used in switch to activate biometry
  registerSecret(secret, successCallback, errorCallback) {
    console.log('[registerSecret] secret: ', secret);
    const infoErrorCallback = (error) => {
      console.info('Falha no registro da biometria:', error);
      if (errorCallback) {
        errorCallback(error);
      }
    };

    const description = VueI18n.t('BIOMETRY').Register_Biometric_Secret_Desc;

    console.log('[registerSecret] Fingerprint.registerBiometricSecret');
    Fingerprint.registerBiometricSecret({
      description: description,
      secret: secret,
      invalidateOnEnrollment: true,
      disableBackup: true,
    }, successCallback, infoErrorCallback);

    // this.activateBiometry(successCallback, infoErrorCallback);
  }

  // Used in login
  loadSecret(successCallback, errorCallback) {
    const disableBackup = false;
    const fallbackButtonTitle = disableBackup ? VueI18n.t('BIOMETRY').Cancel : VueI18n.t('BIOMETRY').Use_Pin;
    const infoErrorCallback = (error) => {
      console.info('Falha ao carregar o segredo biométrico:', error);
      if (errorCallback) {
        errorCallback(error);
      }
    };
    const description = VueI18n.t('BIOMETRY').Show_Fingerprint_Desc;
    Fingerprint.loadBiometricSecret({
      description: description,
      fallbackButtonTitle: fallbackButtonTitle,
      disableBackup: disableBackup,
    }, successCallback, infoErrorCallback);
  }

  // hasBiometry(successCallback, errorCallback) {
  //   Fingerprint.isAvailable(
  //     successCallback,
  //     errorCallback,
  //     {allowBackup: true}
  //   );
  // }

  hasBiometry(successCallback, errorCallback) {
    const infoErrorCallback = (error) => {
      console.info('Falha ao verificar a disponibilidade da biometria:', error);
      if (errorCallback) {
        errorCallback(error);
      }
    };
    try {
      Fingerprint.isAvailable(
        successCallback,
        infoErrorCallback,
        { allowBackup: true }
      );
    } catch (error) {
      infoErrorCallback(error);
    }
  }



  // REACT NATIVE COMMUNICATION
  waitCheckHasBiometry() {
    console.log('[waitCheckHasBiometry] init')
    if (!window.ReactNativeWebView) return false;
    this.isBiometryAvailable();
    let receivedMessageFromApp = false;

    return new Promise((resolve, reject) => {
      console.log('[waitCheckHasBiometry][listener][Promise] Enter promisse, load function listener');
      const listenerCheckHasBiometry = (event) => {
        console.log('[waitCheckHasBiometry][listener] Received message ', JSON.stringify(event.data));
        if (event.data.name === "isBiometryAvailable") {
          window.removeEventListener("message", listenerCheckHasBiometry);
          store.dispatch('updateIsBiometryAvailable', event.data.data ? true : false);
          store.dispatch('updateBiometryType', event.data.data);
          receivedMessageFromApp = true;
          resolve(event.data.data);
        }
      };

      console.log('[waitCheckHasBiometry][Timeout] creating timeout ', reactResponseTimeout);
      const timeoutId = setTimeout(() => {
        if (!receivedMessageFromApp) {
          console.log('[waitCheckHasBiometry][Timeout] Nenhuma resposta recebida do postMessage', reactResponseTimeout);
          reject(new Error("Timeout: Nenhuma resposta recebida do postMessage."));
          // removing listener
          window.removeEventListener("message", listenerCheckHasBiometry);
        }
      }, reactResponseTimeout);

      window.addEventListener("message", listenerCheckHasBiometry);
    });
  }

  waitSaveBiometrySecret(secret) {
    if (!window.ReactNativeWebView) return false;
    this.saveBiometrySecret(secret);
    let receivedMessageFromApp = false;

    return new Promise((resolve, reject) => {
      const listenerSaveBiometrySecret = (event) => {
        console.log('[waitSaveBiometrySecret][listener] Received message ', JSON.stringify(event.data));
        if (event.data.name === "saveBiometrySecret") {
          window.removeEventListener("message", listenerSaveBiometrySecret);
          store.dispatch('updateBiometrySecrets', event.data.data);
          receivedMessageFromApp = true;
          resolve(event.data.data);
        }
      };

      const timeoutId = setTimeout(() => {
        if (!receivedMessageFromApp) {
          console.log('[waitSaveBiometrySecret][Timeout] Nenhuma resposta recebida do postMessage', reactResponseTimeout);
          reject(new Error("Timeout: Nenhuma resposta recebida do postMessage."));
          window.removeEventListener("message", listenerSaveBiometrySecret);
        }
      }, reactResponseTimeout);
      window.addEventListener("message", listenerSaveBiometrySecret);
    });
  }

  waitGetBiometrySecret(secret) {
    if (!window.ReactNativeWebView) return false;
    this.getBiometrySecret(secret);
    let receivedMessageFromApp = false;
    return new Promise((resolve, reject) => {
      const listenerGetBiometrySecret = (event) => {
        console.log('[waitGetBiometrySecret][listener] Received message ', JSON.stringify(event.data));
        if (event.data.name === "getBiometrySecret") {
          window.removeEventListener("message", listenerGetBiometrySecret);
          // store.dispatch('updateBiometryType', event.data.data);
          store.dispatch('updateBiometrySecrets', event.data.data);
          receivedMessageFromApp = true;
          resolve(event.data.data);
        }
      };
      const timeoutId = setTimeout(() => {
        if (!receivedMessageFromApp) {
          console.log('[waitGetBiometrySecret][Timeout] Nenhuma resposta recebida do postMessage', reactResponseTimeout);
          reject(new Error("Timeout: Nenhuma resposta recebida do postMessage."));
          window.removeEventListener("message", listenerGetBiometrySecret);
        }
      }, reactResponseTimeout);
      window.addEventListener("message", listenerGetBiometrySecret);
    });
  }

  waitHasBiometrySecret() {
    if (!window.ReactNativeWebView) return false;
    this.hasBiometrySecret();
    let receivedMessageFromApp = false;
    return new Promise((resolve, reject) => {
      const listenerHasBiometrySecret = (event) => {
        console.log('[waitHasBiometrySecret][listener] Received message ', JSON.stringify(event.data));
        if (event.data.name === "hasBiometrySecret") {
          window.removeEventListener("message", listenerHasBiometrySecret);
          // store.dispatch('updateBiometryType', event.data.data);
          store.dispatch('updateBiometrySecretsStatus', event.data.data);
          receivedMessageFromApp = true;
          resolve(event.data.data);
        }
      };
      const timeoutId = setTimeout(() => {
        if (!receivedMessageFromApp) {
          console.log('[waitHasBiometrySecret][Timeout] Nenhuma resposta recebida do postMessage', reactResponseTimeout);
          reject(new Error("Timeout: Nenhuma resposta recebida do postMessage."));
          window.removeEventListener("message", listenerHasBiometrySecret);
        }
      }, reactResponseTimeout);
      window.addEventListener("message", listenerHasBiometrySecret);
    });
  }

  waitRemoveBiometrySecret() {
    if (!window.ReactNativeWebView) return false;
    this.removeBiometrySecret();
    let receivedMessageFromApp = false;
    return new Promise((resolve, reject) => {
      const listenerRemoveBiometrySecret = (event) => {
        console.log('[waitHasBiometrySecret][listener] Received message ', JSON.stringify(event.data));
        if (event.data.name === "removeBiometrySecret") {
          window.removeEventListener("message", listenerRemoveBiometrySecret);
          // store.dispatch('updateBiometryType', event.data.data);
          store.dispatch('updateBiometrySecretsStatus', event.data.data);
          receivedMessageFromApp = true;
          resolve(event.data.data);
        }
      };
      const timeoutId = setTimeout(() => {
        if (!receivedMessageFromApp) {
          console.log('[waitHasBiometrySecret][Timeout] Nenhuma resposta recebida do postMessage', reactResponseTimeout);
          reject(new Error("Timeout: Nenhuma resposta recebida do postMessage."));
          window.removeEventListener("message", listenerHasBiometrySecret);
        }
      }, reactResponseTimeout);
      window.addEventListener("message", listenerHasBiometrySecret);
    });
  }

  waitDisplayBiometry() {
    if (!window.ReactNativeWebView) return false;
    this.displayBiometry();
    let receivedMessageFromApp = false;
    return new Promise((resolve, reject) => {
      const listener = (event) => {
        console.log('[waitDisplayBiometry][listener] Received message ', JSON.stringify(event.data));
        if (event.data.name === "displayBiometry") {
          window.removeEventListener("message", listener);
          receivedMessageFromApp = true;
          resolve(event.data.data);
        }
      };

      const timeoutId = setTimeout(() => {
        if (!receivedMessageFromApp) {
          console.log('[waitDisplayBiometry][Timeout] Nenhuma resposta recebida do postMessage', reactResponseTimeout);
          reject(new Error("Timeout: Nenhuma resposta recebida do postMessage."));
          window.removeEventListener("message", listener);
        }
      }, reactResponseTimeout);
      window.addEventListener("message", listener);
    });
  }
  waitGetOneSignalID() {
    if (!window.ReactNativeWebView) return false;
    this.getOneSignalID();
    let receivedMessageFromApp = false;
    return new Promise((resolve, reject) => {
      const listener = (event) => {
        console.log('[waitGetOneSignalID] Received message ', JSON.stringify(event.data));
        if (event.data.name === "getOneSignalID") {
          window.removeEventListener("message", listener);
          receivedMessageFromApp = true;
          resolve(event.data.data);
        }
      };

      const timeoutId = setTimeout(() => {
        if (!receivedMessageFromApp) {
          console.log('[waitGetOneSignalID][Timeout] Nenhuma resposta recebida do postMessage', reactResponseTimeout);
          reject(new Error("Timeout: Nenhuma resposta recebida do postMessage."));
          window.removeEventListener("message", listener);
        }
      }, reactResponseTimeout);
      window.addEventListener("message", listener);
    });
  }

  isBiometryAvailable() {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: 'isBiometryAvailable',
        })
      );
      console.log('[ReactNativeWebView][isBiometryAvailable] sent to app isBiometryAvailable message');
    } else {
      console.log('[ReactNativeWebView] not found');
    }
  }
  getBiometrySecret() {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: 'getBiometrySecret',
        })
      );
    } else {
      console.log('[ReactNativeWebView] not found');
    }

  }
  hasBiometrySecret() {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: 'hasBiometrySecret',
        })
      );
    } else {
      console.log('[ReactNativeWebView] not found');
    }

  }
  removeBiometrySecret() {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: 'removeBiometrySecret',
        })
      );
    } else {
      console.log('[ReactNativeWebView] not found');
    }

  }
  displayBiometry() {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: 'displayBiometry'
        })
      );
    } else {
      console.log('[ReactNativeWebView] not found');
    }
  }

  saveBiometrySecret(secret) {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: 'saveBiometrySecret',
          secret: secret, 
        })
      );
    } else {
      console.log('[ReactNativeWebView] not found');
    }
  }
  openExternalUrl(url) {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: 'openExternalURL',
          url: url
        })
      );
    } else {
      console.log('[ReactNativeWebView] not found');
    }
  }
  openImage(url, mimeType) {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: 'openImage',
          url: url,
          mimeType: mimeType
        })
      );
    } else {
      console.log('[ReactNativeWebView] not found');
    }
  }
  openDocument(url, filename, extension, mimeType, blob) {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: 'openDocument',
          url: url,
          filename: filename,
          extension: extension,
          mimeType: mimeType,
          blob: blob
        })
      );
    } else {
      console.log('[ReactNativeWebView] not found');
    }
  }
  getOneSignalID() {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: 'getOneSignalID'
        })
      );
    } else {
      console.log('[ReactNativeWebView] not found');
    }
  }

  setLanguage() {
    if (window.ReactNativeWebView) {
      console.log('[setLanguage][appReact]');
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: 'setLanguage',
          locale: getMomentLocale(i18n.locale)
        })
      );
    } else {
      console.log('[ReactNativeWebView] not found');
    }
  }

  initData() {
    const biometry = localStorageHelper.getBiometry();
    store.commit('UPDATE_BIOMETRY', biometry);
    const biometrySecrets = localStorageHelper.getBiometrySecrets();
    store.commit('UPDATE_BIOMETRY_SECRETS', biometrySecrets);
    const hasBiometry = localStorageHelper.getHasBiometry();
    store.commit('UPDATE_HAS_BIOMETRY', hasBiometry);
    const isBiometryAvailable = localStorageHelper.getIsBiometryAvailable();
    store.commit('UPDATE_IS_BIOMETRY_AVAILABLE', isBiometryAvailable);
    const biometrySecretsStatus = localStorageHelper.getBiometrySecretsStatus();
    store.commit('UPDATE_BIOMETRY_SECRETS_STATUS', biometrySecretsStatus);
    const biometryType = localStorageHelper.getBiometryType();
    store.commit('UPDATE_BIOMETRY_TYPE', biometryType);
  }

}

export default new BiometryHelper();
